import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import "./UserLogin.css";
import { useSEO } from "../../context/SEOContext";
import { useTranslation } from "react-i18next";
const UserLogin = () => {
  const { t } = useTranslation();
  const setSeo = useSEO();
  useEffect(() => {
    setSeo({
      title: t("login.meta.title"),
      description: t("login.meta.description"),
      keywords: t("login.meta.keywords"),
      favicon: "/faviconnew.png", // ✅ burada favicon tanımlandı
    });
  }, [setSeo, t]);

  const [email, setEmail] = useState(""); // email state'ini tanımladık
  const [password, setPassword] = useState(""); // password state'ini tanımladık

  const isPasswordStrong = (password) => {
    const strongPasswordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{6,}$/;
    return strongPasswordRegex.test(password);
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Formun sayfayı yenilemesini engelle

    if (!isPasswordStrong(password)) {
      Swal.fire({
        icon: "warning",
        title: t("alerts.weakPasswordTitle"),
        text: t("alerts.weakPasswordText"),
        confirmButtonText: t("OK"),
      });
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }), // email ve password bilgilerini API'ye gönderiyoruz
      });

      const responseText = await response.text(); // Yanıtı ham metin olarak alıyoruz
      // console.log(responseText); // Yanıtı konsola yazdırıyoruz

      // Yanıt JSON formatında ise, JSON'a çeviriyoruz
      let data = {};
      try {
        data = JSON.parse(responseText); // JSON.parse ile yanıtı JSON'a çeviriyoruz
      } catch (e) {
        console.error("Yanıt JSON değil:", e); // JSON hatası varsa, konsola yazdırıyoruz
      }

      if (response.ok && data.user) {
        sessionStorage.setItem("user_id", data.user.id);
        localStorage.setItem("userId", data.user.id); // yine saklayabilirsin istersen
        localStorage.setItem("user", JSON.stringify(data.user)); // Kullanıcı bilgilerini localStorage'a kaydediyoruz
        Swal.fire({
          icon: "success",
          title: t("LoginSuccessful"),
          text: t("WelcomeUser", { name: data.user.name }),
          confirmButtonText: t("OK"),
        }).then(() => {
          // Yönlendirme işlemi
          window.location.href = `/profile/${data.user.id}`;
        });
      } else {
        Swal.fire({
          icon: "error",
          title: t("AlertErrorTitle"),
          text: t("invalidCredentials") || data.error,
          confirmButtonText: t("OK"),
        });
      }
    } catch (error) {
      console.error("API Hatası:", error); // Detaylı hata mesajını konsola yazdırıyoruz
      Swal.fire({
        icon: "error",
        title: t("APIerrortitle"),
        text: t("APIerrortext"),
        confirmButtonText: t("OK"),
      });
    }
  };

  return (
    <>
      <div className="container py-5">
        <div className="row justify-content-center align-items-center">
          <div className="col-lg-6 col-md-12">
            <h3 className="formtitleh1">{t("WelcomeBack")}</h3>
            <p className="formbtnfontsize fw-14">{t("SignInInstruction")}</p>
            <p className="text-end py-1 mb-0 footertitle300">
              {t("RequiredFields")}
            </p>
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label footertitle300">
                  {t("Email")}
                </label>
                <input
                  type="email"
                  className="form-control"
                  id="email-input" // Benzersiz id değeri
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)} // email state'ini güncelle
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label footertitle300">
                  {t("Password")}
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="password-input" // Benzersiz id değeri
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)} // password state'ini güncelle
                  required
                />
              </div>

              {/* <p>
                <a href="./forgetpassword" className="text-dark footertitle300">
                  Forgot your password?
                </a>
              </p> */}

              <div className="col-lg-12 text-end">
                <button
                  type="submit"
                  className="btn bgcolorfooterbottom pe-5 px-5 formbtnfontsize w-100 p-2"
                >
                  {t("Login")}
                </button>
                <p className="mt-3 formbtnfontsize">
                  {t("DontHaveAccount")}
                  <br />
                  <a href="/createaccount" className="text-dark">
                    {t("CreateAccount")}
                  </a>
                </p>
              </div>
            </form>
          </div>
          <div className="col-lg-5 offset-lg-1 col-md-12 mt-sm-4 mt-4">
            <div className="rightcardbg p-5">
              <p className="footertitle300 text-lighter text-uppercase">
                {t("MukemelAccountInfoTitle")}
              </p>
              <p className="fontsize14">
                <i className="far fa-user me-2"></i>
                {t("ManagePersonalInfo")}
              </p>
              <hr />
              <p className="fontsize14">
                <i className="far fa-envelope-open me-2"></i>
                {t("ReceiveEmails")}
              </p>
              <hr />
              <p className="fontsize14">
                <i className="far fa-heart me-2"></i>
                {t("CreateWishlist")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserLogin;
